// extracted by mini-css-extract-plugin
module.exports = {"link":"TextLink_link__14vYM","link_text":"TextLink_link_text__8WFdR","link_icon":"TextLink_link_icon__1IJq5"};